import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState('register');  // 'login' | 'register' — new app, register first
  const [name, setName] = useState('');
  const [passphrase, setPass] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      if (mode === 'login') await login(name, passphrase);
      else await register(name, passphrase);
    } catch (err) {
      setError(err.message || '發生錯誤');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-screen">
      <form className="login-card" onSubmit={submit}>
        <h2>3S4T賽德克語聖經</h2>
        <p className="login-sub">{mode === 'login' ? '登入以繼續' : '建立新使用者'}</p>

        <label>名稱
          <input value={name} onChange={e => setName(e.target.value)} autoFocus
                 placeholder="你的名稱" />
        </label>
        <label>密語
          <input type="password" value={passphrase} onChange={e => setPass(e.target.value)}
                 placeholder="密語（可留空）" />
        </label>

        {error && <div className="login-error">{error}</div>}

        <button type="submit" className="login-btn" disabled={busy || !name.trim()}>
          {busy ? '…' : (mode === 'login' ? '登入' : '建立')}
        </button>

        <button type="button" className="login-switch"
          onClick={() => { setMode(m => m === 'login' ? 'register' : 'login'); setError(''); }}>
          {mode === 'login' ? '沒有帳號？建立新使用者' : '已有帳號？登入'}
        </button>
      </form>
    </div>
  );
}
